import { useEffect, useState } from "react";
import { updateIgo, fetchIgoById, setIgoLogo, getIgoThemes } from "../../HTTP/countries";
import { useParams } from "react-router-dom";
import { getAllCountries } from "../../HTTP/translation";

export default function EditIgo() {

  const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 5) {
        window.location.href = '/'
    }

    const { id } = useParams()

    const [formData, setFormData] = useState({
        name: '',
        label: '',
        country_list: '',
        igo_theme_id_list: '',
        acronyms: [''],
        image : null
    });

    // États pour la recherche de pays
    const [countriesList, setCountriesList] = useState([]);
    const [countrySearch, setCountrySearch] = useState('');
    const [filteredCountries, setFilteredCountries] = useState(countriesList);
    const [igoThemes, setIgoThemes] = useState([]);
    
    useEffect(() => {
        const fetchIgo = async () => {
            const res = await fetchIgoById(id)
            setFormData({
                id: res.id,
                name: res.name,
                label: res.label,
                link: res.link,
                country_list: res.country_list,
                igo_theme_id_list: res.igo_theme_id_list === null ? '' : res.igo_theme_id_list,
                acronyms: Array.isArray(res.acronyms) && res.acronyms.length > 0 ? res.acronyms : [''],
                image: res.image,
            })
            console.log(res)
        }
        fetchIgo()
    }, [id])

        // États pour la recherche de thèmes IGO
        const [themeSearch, setThemeSearch] = useState('');
        const [filteredThemes, setFilteredThemes] = useState(igoThemes);
    
        useEffect(() => {
            const fetchIgoThemes = async () => {
                try {
                    const response = await getIgoThemes();
                    if (response) {
                        setIgoThemes(response);
                        setFilteredThemes(response);
                    }
                } catch (error) {
                    console.error("Erreur lors de la récupération des thèmes IGO:", error);
                }
            };
            const fetchCountries = async () => {
                try {
                    const response = await getAllCountries();
                    if (response) {
                        setCountriesList(response);
                        setFilteredCountries(response);
                    }
                } catch (error) {
                    console.error("Erreur lors de la récupération des pays:", error);
                }
            };
            fetchCountries();
            fetchIgoThemes();
        }, []);

    // Filtrer les pays en fonction de la recherche
    const filterCountries = (searchTerm) => {
        if (searchTerm.trim() === '') {
            setFilteredCountries(countriesList);
        } else {
            const filtered = countriesList.filter(country =>
                country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                country.code.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredCountries(filtered);
        }
    };

        const filterThemes = (searchTerm) => {
        if (searchTerm.trim() === '') {
            setFilteredThemes(igoThemes);
        } else {
            const filtered = igoThemes.filter(theme =>
                theme.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredThemes(filtered);
        }
    };

    const handleThemeSearchChange = (e) => {
        const searchValue = e.target.value;
        setThemeSearch(searchValue);
        filterThemes(searchValue);
    }

    const handleCountrySearchChange = (e) => {
        const searchValue = e.target.value;
        setCountrySearch(searchValue);
        filterCountries(searchValue);
    };

    // Obtenir les pays sélectionnés pour l'affichage
    const getSelectedCountries = () => {
        const selectedCodes = formData.country_list.split(',').filter(Boolean);
        return countriesList.filter(country => selectedCodes.includes(country.code));
    };

    const getSelectedThemes = () => {
        const selectedIds = formData.igo_theme_id_list.split(',').filter(Boolean);
        return igoThemes.filter(theme => selectedIds.includes(String(theme.id)));
    };

    // Effacer la recherche
    const clearCountrySearch = () => {
        setCountrySearch('');
        setFilteredCountries(countriesList);
    };

    const clearThemeSearch = () => {
        setThemeSearch('');
        setFilteredThemes(igoThemes);
    };

    // Fonction pour formater le texte (minuscules et tirets au lieu d'espaces)
    const formatText = (text) => {
        return text.toLowerCase().replace(/\s+/g, '-');
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        // Mettre à jour le champ modifié
        const updatedFormData = {
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        };
        
        // Si c'est le champ label qui est modifié, on vérifie si le nom correspond au format du label
        // Si oui, on continue à mettre à jour le nom automatiquement
        if (name === 'label') {
            const formattedLabel = formatText(value);
            // On vérifie si le champ nom est vide OU s'il correspond au format du label précédent
            // Si c'est le cas, on continue à mettre à jour automatiquement le champ nom
            if (formData.name === '' || formData.name === formatText(formData.label)) {
                updatedFormData.name = formattedLabel;
            }
        }
        
        setFormData(updatedFormData);
        console.log(updatedFormData);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const normalizedAcronyms = (formData.acronyms || [])
                .map((acronym) => acronym.trim())
                .filter(Boolean);

            // Mise à jour des données sans l'image
            const formwithoutImage = {
                id: formData.id,
                name: formData.name,
                label: formData.label,
                country_list: formData.country_list,
                igo_theme_id_list: formData.igo_theme_id_list,
                link: formData.link,
                acronyms: normalizedAcronyms,
            };
            const res = await updateIgo(formwithoutImage);
            
            // Vérifier si res est vraiment un succès (selon votre API)
            if (res) {
                // Si une image est présente, la télécharger
                if (formData.image) {
                    console.log("Image à télécharger", formData.image);
                    const res2 = await setIgoLogo(formData.id, formData.image);
                    console.log("res2", res2);
                    if (res2) {
                        console.log("Image téléchargée avec succès");
                        alert('Igo modifié avec succès avec image');
                    } else {
                        // Ne pas rediriger en cas d'échec du téléchargement d'image
                        alert("Erreur lors de l'ajout de l'image");
                        return; // Empêcher la redirection
                    }
                } else {
                    alert('Igo modifié avec succès sans image');
                }
                window.location.href = "/admin/igo";
            } else {
                alert("Erreur lors de la modification de l'organisation");
            }
        } catch (error) {
            console.error("Erreur lors de la modification de l'organisation:", error);
            alert("Erreur lors de la modification de l'organisation");
        }
    };

    const handleAcronymChange = (index, value) => {
        const nextAcronyms = [...(formData.acronyms || [])];
        nextAcronyms[index] = value;
        setFormData({ ...formData, acronyms: nextAcronyms });
    };

    const handleAddAcronym = () => {
        setFormData({
            ...formData,
            acronyms: [...(formData.acronyms || []), '']
        });
    };

    const handleRemoveAcronym = (index) => {
        const current = formData.acronyms || [];
        if (current.length <= 1) {
            setFormData({ ...formData, acronyms: [''] });
            return;
        }
        const nextAcronyms = current.filter((_, i) => i !== index);
        setFormData({ ...formData, acronyms: nextAcronyms });
    };

    return (
        <div className="mt-8 max-w-md mx-auto p-6 bg-white rounded-lg shadow-md md:overflow-y-auto" style={{ maxHeight: window.innerWidth >= 768 ? 'calc(100vh - 100px)' : undefined }}>
            <h2 className="text-2xl font-bold mb-6 text-center">Modifier une organisation</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="label" className="block text-gray-700 text-sm font-bold mb-2">
                        Label :
                    </label>
                    <input
                        type="text"
                        name="label"
                        id="label"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        value={formData.label}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
                        Nom : <span className="text-xs text-gray-500">(Automatiquement formaté sans majuscules ni espaces)</span>
                    </label>
                    <input
                        type="text"
                        name="name"
                        id="name"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        value={formData.name}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="link" className="block text-gray-700 text-sm font-bold mb-2">
                        Lien vers le site officiel :
                    </label>
                    <input
                        type="text"
                        name="link"
                        id="link"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        value={formData.link}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                        Acronymes :
                    </label>
                    <div className="space-y-2">
                        {(formData.acronyms || ['']).map((acronym, index) => (
                            <div key={`acronym-${index}`} className="flex items-center gap-2">
                                <input
                                    type="text"
                                    value={acronym}
                                    onChange={(e) => handleAcronymChange(index, e.target.value)}
                                    className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    placeholder="Ex: ONU"
                                />
                                <button
                                    type="button"
                                    onClick={() => handleRemoveAcronym(index)}
                                    className="px-2 py-2 text-red-600 hover:text-red-800"
                                    aria-label={`Supprimer l'acronyme ${index + 1}`}
                                >
                                    ✕
                                </button>
                            </div>
                        ))}
                    </div>
                    <button
                        type="button"
                        onClick={handleAddAcronym}
                        className="mt-2 text-sm text-blue-600 hover:text-blue-800"
                    >
                        + Ajouter un acronyme
                    </button>
                </div>
                <div className="mb-4">
                    <label htmlFor="country_list" className="block text-gray-700 text-sm font-bold mb-2">
                        Liste des pays :
                    </label>
                    
                    {/* Champ de recherche */}
                    <div className="mb-3 relative">
                        <input
                            type="text"
                            placeholder="Rechercher un pays..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            value={countrySearch}
                            onChange={handleCountrySearchChange}
                        />
                        {countrySearch && (
                            <button
                                type="button"
                                onClick={clearCountrySearch}
                                className="absolute right-2 top-2 text-gray-400 hover:text-gray-600"
                            >
                                ✕
                            </button>
                        )}
                    </div>
                    
                    {/* Liste des pays avec checkboxes */}
                    <div className="max-h-48 overflow-y-auto border border-gray-300 rounded-md p-2">
                        {filteredCountries.length === 0 ? (
                            <div className="text-gray-500 text-center py-4">
                                Aucun pays trouvé pour "{countrySearch}"
                            </div>
                        ) : (
                            filteredCountries.map((country) => (
                                <div key={country.code} className="flex items-center mb-2">
                                    <input
                                        type="checkbox"
                                        id={`country-${country.code}`}
                                        name="country_list"
                                        value={country.code}
                                        checked={formData.country_list.split(',').includes(country.code)}
                                        onChange={(e) => {
                                            const selectedCountries = formData.country_list.split(',').filter(Boolean);
                                            if (e.target.checked) {
                                                selectedCountries.push(country.code);
                                            } else {
                                                const index = selectedCountries.indexOf(country.code);
                                                if (index > -1) {
                                                    selectedCountries.splice(index, 1);
                                                }
                                            }
                                            setFormData({ ...formData, country_list: selectedCountries.join(',') });
                                        }}
                                        className="mr-2"
                                    />
                                    <label htmlFor={`country-${country.code}`} className="text-gray-700 cursor-pointer flex-1">
                                        {country.name} <span className="text-gray-400 text-sm notranslate">({country.code})</span>
                                    </label>
                                </div>
                            ))
                        )}
                    </div>
                    
                    {/* Affichage des pays sélectionnés - toujours visible et en bas */}
                    <div className="mt-3 p-2 bg-blue-50 rounded-md">
                        <div className="text-sm font-medium text-blue-800 mb-1">
                            Pays sélectionnés ({getSelectedCountries().length}) :
                        </div>
                        <div className="flex flex-wrap gap-1">
                            {getSelectedCountries().length === 0 ? (
                                <span className="text-blue-600 text-sm italic">Aucun pays sélectionné</span>
                            ) : (
                                getSelectedCountries().map((country) => (
                                    <span
                                        key={country.code}
                                        className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800"
                                    >
                                        {country.name}
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const selectedCountries = formData.country_list.split(',').filter(Boolean);
                                                const index = selectedCountries.indexOf(country.code);
                                                if (index > -1) {
                                                    selectedCountries.splice(index, 1);
                                                }
                                                setFormData({ ...formData, country_list: selectedCountries.join(',') });
                                            }}
                                            className="ml-1 text-blue-600 hover:text-blue-800"
                                        >
                                            ✕
                                        </button>
                                    </span>
                                ))
                            )}
                        </div>
                    </div>
                </div>

                
                <div className="mb-4">
                    <label htmlFor="country_list" className="block text-gray-700 text-sm font-bold mb-2">
                        Thèmes des Forums Globaux :
                    </label>
                    
                    {/* Champ de recherche */}
                    <div className="mb-3 relative">
                        <input
                            type="text"
                            placeholder="Rechercher un thème de Forum global..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            value={themeSearch}
                            onChange={handleThemeSearchChange}
                        />
                        {themeSearch && (
                            <button
                                type="button"
                                onClick={clearThemeSearch}
                                className="absolute right-2 top-2 text-gray-400 hover:text-gray-600"
                            >
                                ✕
                            </button>
                        )}
                    </div>
                    


                    {/* Liste des thèmes OIG avec checkboxes */}
                    <div className="max-h-48 overflow-y-auto border border-gray-300 rounded-md p-2">
                        {filteredThemes.length === 0 ? (
                            <div className="text-gray-500 text-center py-4">
                                Aucun thème de Forum global trouvé pour "{themeSearch}"
                            </div>
                        ) : (
                            filteredThemes.map((theme) => (
                                <div key={theme.id} className="flex items-center mb-2">
                                    <input
                                        type="checkbox"
                                        id={`theme-${theme.id}`}
                                        name="igo_theme_id_list"
                                        value={theme.id}
                                        checked={formData.igo_theme_id_list.split(',').includes(String(theme.id))}
                                        onChange={(e) => {
                                            const selectedThemes = formData.igo_theme_id_list.split(',').filter(Boolean);
                                            const id = String(theme.id);

                                            if (e.target.checked) {
                                            if (!selectedThemes.includes(id)) selectedThemes.push(id);
                                            } else {
                                            const index = selectedThemes.indexOf(id);
                                            if (index > -1) selectedThemes.splice(index, 1);
                                            }
                                            setFormData({ ...formData, igo_theme_id_list: selectedThemes.join(',') });
                                        }}
                                        className="mr-2"
                                        />
                                    <label htmlFor={`theme-${theme.id}`} className="text-gray-700 cursor-pointer flex-1">
                                        {theme.name} <span className="text-gray-400 text-sm">({theme.id})</span>
                                    </label>
                                </div>
                            ))
                        )}
                    </div>
                    
                    {/* Affichage des thèmes sélectionnés - toujours visible et en bas */}
                    <div className="mt-3 p-2 bg-blue-50 rounded-md">
                        <div className="text-sm font-medium text-blue-800 mb-1">
                            Thèmes sélectionnés ({getSelectedThemes().length}) :
                        </div>
                        <div className="flex flex-wrap gap-1">
                            {getSelectedThemes().length === 0 ? (
                                <span className="text-blue-600 text-sm italic">Aucun thème sélectionné</span>
                            ) : (
                                getSelectedThemes().map((theme) => (
                                    <span
                                        key={theme.id}
                                        className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-blue-100 text-blue-800"
                                    >
                                        {theme.name}
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const selectedThemes = formData.igo_theme_id_list.split(',').filter(Boolean);
                                                const index = selectedThemes.indexOf(theme.id);
                                                if (index > -1) {
                                                    selectedThemes.splice(index, 1);
                                                }
                                                setFormData({ ...formData, igo_theme_id_list: selectedThemes.join(',') });
                                            }}
                                            className="ml-1 text-blue-600 hover:text-blue-800"
                                        >
                                            ✕
                                        </button>
                                    </span>
                                ))
                            )}
                        </div>
                    </div>
                </div>

                <div className="mb-4">
                    <label htmlFor="image" className="block text-gray-700 text-sm font-bold mb-2">
                        Image :
                    </label>
                    <input
                        type="file"
                        name="image"
                        id="image"
                        accept="image/*"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
                    />
                    {
                        formData.image && typeof formData.image === 'string' ? (
                            // Show the existing image from the server
                            <img
                                src={'http:'+formData.image}
                                alt="Preview"
                                className="mt-2 w-full h-auto rounded-md"
                            />
                        ) : formData.image instanceof File ? (
                            // Show the new file that was just uploaded
                            <img
                                src={URL.createObjectURL(formData.image)}
                                alt="Preview"
                                className="mt-2 w-full h-auto rounded-md"
                            />
                        ) : null
                    }
                </div>
                <div className="flex items-center justify-end">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                        Enregistrer
                    </button>
                </div>
            </form>
        </div>
    );
}
